export class AccountActivate {
    public email: string;
    public token: string;
    public isValid: boolean;
    public isActivated: boolean;
}
